export default {"wrapper":"D-K6Y","miniBetslip":"_9Ugs-","betCount":"eSiKK","betAdded":"pXDeJ","pulse_animation":"RSc2Y","betslipText":"sZg34 H9fHT UzvkT"};